import React from 'react';

import { Image } from '@vw-marketing/us-components';

import { StyledImageContainer } from './styled';

export const ImageContainer = ({ imgSource }: { imgSource: string }) => {
  return (
    <StyledImageContainer data-testid="image-container">
      <Image src={imgSource} className="vehicle-image" alt="vehicle-image" />
    </StyledImageContainer>
  );
};
